import { Region } from '@heidi/schema/ml-scribe';

import { getCommerceTrialsUiPorts } from '../trials-ui-ports';
import { type ClinicianTrialRecapTestimonialVariant } from './message';

export function resolveClinicianTrialRecapTestimonialVariant(
  region: Region,
  country: string | null | undefined
): ClinicianTrialRecapTestimonialVariant {
  const normalizedCountry = getCommerceTrialsUiPorts().normalizeCountryName(country);
  if (normalizedCountry === 'New Zealand') return 'nz';
  if (region === Region.US || region === Region.US_AZ1) return 'us';
  if (region === Region.CA) return 'ca';
  return 'au';
}
